<template>
  <div class="col-12 col-md-6 form-group form-group-sm">
    <label class="label" for="sensorIN2">Sensor en IN 2</label>
    <multiselect-item
      id="sensorIN2"
      v-model="sensorIN2"
      :custom-label="label"
      :options="sensorIN2Options"
      placeholder="Sensor en IN 2"
      track-by="id_alertas_lista"
    ></multiselect-item>
  </div>
</template>

<script>
import { get } from "lodash-es";
import axios from "axios";

export default {
  name: "SelectSensorIN2",
  beforeMount() {
    this.getAlertas().then((resp) => {
      if (!resp.ok) {
        this.$msgBoxOk(resp.message);
      }
    });
  },
  data: () => ({
    sensorIN2Options: [],
  }),
  methods: {
    label(sensorIN2) {
      return sensorIN2.nombre;
    },
    async getAlertas() {
      const resp = await axios.post("/execute", {
        method: "CLI.GetAlertasSensores",
        parameters: [],
      });

      this.sensorIN2Options = get(resp, "data.result[0]", []);
      return resp.data;
    },
  },
  computed: {
    sensorIN2: {
      get() {
        return this.$store.state.Contratos.NuevoContrato.sensorIN2;
      },
      set(val) {
        this.$store.commit("Contratos/NuevoContrato/setSensorIN2", val);
      },
    },
  },
};
</script>
